function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 3H2.5C1.67157 3 1 3.67157 1 4.5V14.5C1 15.3284 1.67157 16 2.5 16H3.5H5.5H15H17H17.5C18.3284 16 19 15.3284 19 14.5V4.5C19 3.67157 18.3284 3 17.5 3H12.5H7.5ZM17.5 17C18.8807 17 20 15.8807 20 14.5V4.5C20 3.11929 18.8807 2 17.5 2H12.95C12.7184 0.85888 11.7095 0 10.5 0H9.5C8.29052 0 7.28164 0.85888 7.05001 2H2.5C1.11929 2 0 3.11929 0 4.5V14.5C0 15.8807 1.11929 17 2.5 17H3V17.25C3 17.9404 3.55964 18.5 4.25 18.5H4.75C5.44036 18.5 6 17.9404 6 17.25V17H14.5V17.25C14.5 17.9404 15.0596 18.5 15.75 18.5H16.25C16.9404 18.5 17.5 17.9404 17.5 17.25V17ZM16.5 17H15.5V17.25C15.5 17.3881 15.6119 17.5 15.75 17.5H16.25C16.3881 17.5 16.5 17.3881 16.5 17.25V17ZM4 17.25V17H5V17.25C5 17.3881 4.88807 17.5 4.75 17.5H4.25C4.11193 17.5 4 17.3881 4 17.25ZM11.9146 2C11.7087 1.4174 11.1531 1 10.5 1H9.5C8.84689 1 8.29127 1.4174 8.08535 2H11.9146ZM6 5.5C6 5.22386 5.77614 5 5.5 5C5.22386 5 5 5.22386 5 5.5V13.5C5 13.7761 5.22386 14 5.5 14C5.77614 14 6 13.7761 6 13.5V5.5ZM14.5 5C14.7761 5 15 5.22386 15 5.5V13.5C15 13.7761 14.7761 14 14.5 14C14.2239 14 14 13.7761 14 13.5V5.5C14 5.22386 14.2239 5 14.5 5Z",
  fill: "#FFAF00"
});
const SvgLuggage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLuggage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/luggage.84a058a3.svg";
export { ForwardRef as ReactComponent };